enum DSP {
  DV360 = 34,
  TTD = 16,
  GAM = 6,
}
enum AiDSP {
  DV360 = 'Display Video 360 (DV360)',
  TTD = 'The Trade Desk (TTD)',
  GAM = 'Google Ad Manager',
}

enum AiCampaignMetric {
  ClickTroughRate = 'Click Trough Rate',
  Conversions = 'Conversions',
  Custom = 'Custom Attribution',
}

enum CampaignObjective {
  BrandAwareness = 'Brand Awareness',
  LeadGeneration = 'Lead Generation',
  WebsiteTraffic = 'Website Traffic',
  Engagement = 'Engagement',
  AppInstalls = 'App Installs',
  VideoViews = 'Video Views',
  SalesConversions = 'Sales/Conversions',
  ProductCatalogSales = 'Product Catalog Sales',
  StoreVisits = 'Store Visits',
  EventResponses = 'Event Responses',
  SalesConversionsRetargeting = 'Sales/Conversions of retargeted users (retargeting)',
  NearestStoreAwareness = 'Nearest Store awareness',
  NewProductServiceLaunch = 'New product/service launch',
  IncreaseROI = 'Increase ROI',
  IncreasingMarketShare = 'Increasing market share (using conquesting or prospecting strategies)',
}

enum AccountVertical {
  Ecommerce = 'Ecommerce',
  Retail = 'Retail',
  Auto = 'Auto',
  Food = 'Food',
}

enum StrategySignal {
  Audiences = 'Audiences',
  UserLocation = 'User Location',
  Language = 'Language',
  WebsitePastEngagement = 'Website Past Engagement',
  DateAndTime = 'Date and Time',
  Weather = 'Weather',
  SportsData = 'Sports Data', // not an input signal
  ProductData = 'Product Data', // not an input signal
  StoreData = 'Store Data', // not an input signal
  ContentData = 'Content Data', // not an input signal
}

enum AudiencesSource {
  Placement = 'Placement',
  PlacementCustomParam = 'Placement custom param',
  DspMacro = 'DSP macro',
  AudienceLibrary = 'Audience library',
}

enum DateAndTimeScheduling {
  DateTimeRanges = 'date time ranges',
  DayParting = 'day parting',
}

enum UserLocationGranularity {
  ByNearestStore = 'By Nearest Store',
  ByZipCode = 'By Zip code',
  ByCity = 'By City',
  ByState = 'By State',
  ByCountry = 'By Country',
}

enum UserLocationSource {
  Placement = 'Placement',
  ClinchIp2Loc = 'Clinch IP-2-LOC',
}

enum LanguageSource {
  Placement = 'Placement',
  ByUserCountry = 'By user country',
  ByUserRegion = 'By user region',
  AcceptLanguageHttpHeader = 'accept-language http header',
}

enum WebsitePastEngagementSignal {
  ViewedProducts = 'viewed products',
  PurchasedProducts = 'purchased products',
  ViewedCategories = 'viewed categories',
  VisitedPages = 'visited pages',
}

enum WeatherElement {
  Temperature = ' temperature',
  Cloud = 'cloud',
  Rain = 'rain',
  Snow = 'snow',
}

enum SportsElement {
  Score = 'score',
  LeadingTeam = 'leadingTeam',
  ScheduleStatus = 'scheduleStatus',
  Other = 'other',
}

enum CampaignToolName {
  SaveBrief = 'save-brief',
  GetBrief = 'get-brief',
  AvailableSignals = 'available-signals',
  StrategyKnowledge = 'strategy-knowledge',
  HowToWriteBriefToDesignerAndFeedManager = 'how-to-write-brief-to-designer-and-feed-manager',
  AddCards = 'add-cards',
  DeleteCards = 'delete-cards',
  UpdateCards = 'update-cards',
  ConnectCards = 'connect-cards',
  GetEnabledCampaignTypesAndSubtypes = 'get-enabled-campaign-types-and-subtypes',
  CreateCampaign = 'create-campaign',
}

enum AiCamapignSubType {
  FacebookStandard = 'Standard Campaign',
  FacebookDPA = 'DPA Campaign',
  YoutubeGoogleAds = 'Google Ads',
  YoutubeDV360 = 'DV360',
}

enum AICampaignVersionStatus {
  Draft = 'Draft',
  Active = 'Active',
  PendingActivation = 'Pending Activation',
  Saved = 'Saved',
}

enum CampaignsAgentsToolsNames {
  CreateDraft = 'create-draft',
  NavigateToDraft = 'navigate-to-draft',
  GetCampaignsMetadata = 'get-campaigns-metadata',
  NavigateToCampaignVersion = 'navigate-to-campaign-version',
  NavigateToCampaignsLibrary = 'navigate-to-campaigns-library',
  BatchRenameCampaigns = 'batch-rename-campaigns',
}

export {
  DSP,
  AiDSP,
  AiCampaignMetric,
  CampaignObjective,
  AccountVertical,
  StrategySignal,
  AudiencesSource,
  DateAndTimeScheduling,
  UserLocationGranularity,
  UserLocationSource,
  LanguageSource,
  WeatherElement,
  SportsElement,
  WebsitePastEngagementSignal,
  CampaignToolName,
  AiCamapignSubType,
  AICampaignVersionStatus,
  CampaignsAgentsToolsNames,
};
